import { t } from 'i18next';
import { Instance } from '../models/instance';
import axios from '../middleware/requestInterceptor';

export const instanceApi = {
  getAll: async () => {
      const result = await axios.get('/instances');
      const arrayInstance:Array<Instance> = [];
          result.data.map((instance:Instance) => {
            const date:Date = new Date(instance.createdAt);
            return arrayInstance.push({
              ...instance, createdLocaleDate: date.toLocaleString(t('date.format'))
            })
          })
        return arrayInstance;
  },
  getAllByAccount: async (accountId) => {
      const result = await axios.get(`/instances/${accountId}/instances`);
      return result.data;
  },
  getInstanceById: async (instanceId) => {
      const result = await axios.get(`/instances/${instanceId}`);
      return result.data;
  },
  delete: async (instanceId: number) => {
      const result = await axios.delete(`/instances/${instanceId}`, { data: { instanceId: instanceId } });
      return result;
    },
  getUsers: async () => {
      const result = await axios.get('/instances/users');
      const arrayUser = result.data.map((user) => {
          const date = new Date(user.createdAt);
          return {
              ...user,
              createdLocaleDate: date.toLocaleString(t('date.format'))
          };
      });
      return arrayUser;
  },
  create: async (instance) => {
      const result = await axios.post('/instances',
        {
          accountId: instance.instanceAccountNameValue,
          name: instance.instanceValue,
          type: instance.hostingValueType,
          state: instance.instanceStatusValue,
          environment: instance.environment
        }
      )
      return result;
  },
  update: async (instance: Instance) => {
      const result = await axios.put(`/instances/${instance.instanceId}`,
        {
          accountId: instance.accountId,
          name: instance.name,
          type: instance.type,
          state: instance.state,
          comment: instance.comment,
          instanceId: instance.instanceId,
          environment: instance.environment
        })
      return result;
  },
  exportInstances: async () => {
    try {
      const response = await axios.get('/instances/export', { responseType: 'blob' });
      const blob = new Blob([response.data], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' });
      const url = window.URL.createObjectURL(blob);
      const a = document.createElement('a');
      a.href = url;
      a.download = 'Corporate_List_Instances.xlsx';
      a.click();
      window.URL.revokeObjectURL(url);
    } catch (error) {
      console.error('Error exporting all instances: ', error);
    }
  }
}
